import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { Tooltip } from '@/decodo/components/atoms/Tooltip/Tooltip';
import ToolTipIcon from '~/icons/tooltip_icon.svg';

export interface ComparisonTextProps {
  text?: RichTextFieldStrapiProps | null;
  tooltipText?: RichTextFieldStrapiProps | null;
}

export function ComparisonText({ text, tooltipText }: ComparisonTextProps) {
  if (!text || (typeof text === 'object' && Object.keys(text).length === 0)) {
    return <span className='text-body-m text-base-black'>–</span>;
  }

  return (
    <div className='flex items-start gap-2'>
      <div className='text-body-m text-base-black break-words'>
        <RichTextFieldStrapi
          block={text}
          classNames={{ listUnordered: '!text-body-m py-2 gap-1' }}
        />
      </div>

      {!!tooltipText && (
        <Tooltip
          flowDirection='bottom-center'
          text={<RichTextFieldStrapi block={tooltipText} />}
          classNames={{ text: 'max-w-[200px]' }}
        >
          <ToolTipIcon className='group-hover:text-brand-900 h-5 w-5 cursor-pointer text-gray-400' />
        </Tooltip>
      )}
    </div>
  );
}
